import { bool, node, string } from "prop-types";
import React from "react";
import { Col, Row } from "../Grid";
import Button from "../Button";
import { classes } from "../utils/classes";
import Image from "../Image";

const TestimonialTab = ({ logoImg, active = false }) => {
	return (
		<Col md={4} lg={2}>
			<Button
				className={classes("testimonials-customers__tab ", active && "active")}
				styleType="link"
			>
				<Image src={logoImg} />
			</Button>
		</Col>
	);
};

TestimonialTab.propTypes = {
	logoImg: string.isRequired,
	active: bool,
};

const TestimonialTabs = ({ children }) => {
	return (
		<Row mx my>
			{children}
		</Row>
	);
};

TestimonialTabs.propTypes = {
	children: node.isRequired,
};

export default TestimonialTabs;
